import { render, staticRenderFns } from "./PartyDetails.vue?vue&type=template&id=646c8afa&scoped=true&"
import script from "./PartyDetails.vue?vue&type=script&lang=js&"
export * from "./PartyDetails.vue?vue&type=script&lang=js&"
import style0 from "./PartyDetails.vue?vue&type=style&index=0&id=646c8afa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c8afa",
  null
  
)

export default component.exports